// The management context defines none of these prefixes, so a pasted "dct:title" would be stored
// unexpanded and the connector's DSP catalog request would then fail with HTTP 500.
export const DCAT_METADATA_CONTEXT: Record<string, string> = {
  dcat: 'http://www.w3.org/ns/dcat#',
  dct: 'http://purl.org/dc/terms/',
  dspace: 'https://w3id.org/dspace/2025/1/',
  odrl: 'http://www.w3.org/ns/odrl/2/',
  xsd: 'http://www.w3.org/2001/XMLSchema#',
  foaf: 'http://xmlns.com/foaf/0.1/',
  vcard: 'http://www.w3.org/2006/vcard/ns#',
  adms: 'http://www.w3.org/ns/adms#',
  locn: 'http://www.w3.org/ns/locn#',
  prov: 'http://www.w3.org/ns/prov#',
  skos: 'http://www.w3.org/2004/02/skos/core#',
  gsp: 'http://www.opengis.net/ont/geosparql#',
};

/** Adds the DCAT prefixes to non-empty metadata; a @context the user supplied takes precedence. */
export function withDcatContext(metadata: any): any {
  if (!metadata || typeof metadata !== 'object' || Array.isArray(metadata) || Object.keys(metadata).length === 0) {
    return metadata;
  }
  const { '@context': own, ...rest } = metadata;
  const context = own === undefined
    ? DCAT_METADATA_CONTEXT
    : [DCAT_METADATA_CONTEXT, ...(Array.isArray(own) ? own : [own])];
  return { '@context': context, ...rest };
}
